import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
} from '@angular/core';

import {
	ContractContentBlock,
	ContractTableBlock,
	htmlToMarkdown,
	markdownToHtml,
	parseContractContentBlocks,
	serializeContractContentBlocks,
} from './contract-content-blocks';

@Component({
	selector: 'app-contract-rich-content',
	styleUrls: ['./contract-rich-content.component.scss'],
	templateUrl: './contract-rich-content.component.html',
})
export class ContractRichContentComponent implements OnChanges {
	@Input() editable: boolean = false;
	@Input() value: string = '';
	@Output() readonly valueChange = new EventEmitter<string>();

	blocks: ContractContentBlock[] = [];
	readonly quillModules = {
		toolbar: [
			['bold', 'italic', 'underline', 'strike'],
			[{ list: 'ordered' }, { list: 'bullet' }],
			['blockquote', 'link'],
			['clean'],
		],
	};

	getCellHtml(value: string): string {
		return markdownToHtml(value)
			.replace(/^<p>/u, '')
			.replace(/<\/p>$/u, '');
	}

	ngOnChanges(): void {
		if (
			this.blocks.length === 0 ||
			serializeContractContentBlocks(this.blocks) !== this.value.trim()
		) {
			this.blocks = parseContractContentBlocks(this.value);
		}
	}

	trackBlock(_: number, block: ContractContentBlock): string {
		return block.id;
	}

	trackCell(index: number): number {
		return index;
	}

	updateRichText(blockId: string, html: string | null): void {
		this.blocks = this.blocks.map((block) =>
			block.id === blockId && block.type === 'rich-text'
				? { ...block, html: html ?? '', markdown: htmlToMarkdown(html ?? '') }
				: block,
		);
		this.emitValue();
	}

	updateTableCell(
		blockId: string,
		rowIndex: number,
		cellIndex: number,
		event: Event,
	): void {
		const value = (event.target as HTMLInputElement).value;

		this.blocks = this.blocks.map((block) => {
			if (block.id !== blockId || block.type !== 'table') return block;

			const nextBlock: ContractTableBlock = {
				...block,
				header:
					rowIndex === 0
						? block.header.map((cell, index) =>
								index === cellIndex ? value : cell,
							)
						: block.header,
				rows:
					rowIndex === 0
						? block.rows
						: block.rows.map((row, index) =>
								index === rowIndex - 1
									? row.map((cell, currentCellIndex) =>
											currentCellIndex === cellIndex ? value : cell,
										)
									: row,
							),
			};

			return nextBlock;
		});
		this.emitValue();
	}

	private emitValue(): void {
		this.valueChange.emit(serializeContractContentBlocks(this.blocks));
	}
}
